// extracted by mini-css-extract-plugin
export var fileUpload = "_d2-1";
export var modalButton = "_d2-0";